export default __webpack_public_path__ + "static/media/img12.c4c5cd2e.JPG";